import React from "react";

const FourOhFour = () => <h1>ERROR 404</h1>;

export default FourOhFour;
